// dependencies
import { GenerateProcess } from "redux-process";

// ui
import ui from "./ui";

// actions
import { changePageUI as updateUI } from "Actions/ui";

// selectors
import { getUI } from "Selectors/ui";
import { getReportID } from "./selectors";

/**
 * Fetch (or refetch) the data
 */
export const fetchPageData = () => async (dispatch, getState) => {
	// request
	const state = getState();
	const reportID = getReportID(state);

	// request
	const request = await dispatch(GenerateProcess("GetBugReport", { reportID }));
	const bugReport = request.response.getIn(["data", "bugReport"]);

	dispatch(updateUI(["bugReport"], bugReport));
};

/**
 * Initialize page.
 */
export const init = () => (dispatch) => {
	// set the initial UI
	const initialUI = ui;
	dispatch(updateUI([], initialUI));

	// fetch page data
	dispatch(fetchPageData());
};
